// Test-id constants for the M0 admin shell. Every interactive element gets one.
export const NAV = {
  logo: "nav-logo",
  dashboardLink: "nav-dashboard-link",
  brandsLink: "nav-brands-link",
  rulesLink: "nav-rules-link",
  contentLink: "nav-content-link",
  brandKitLink: "nav-brand-kit-link",
  brandProgramsLink: "nav-brand-programs-link",
  designRequestsLink: "nav-design-requests-link",
  approvalsLink: "nav-approvals-link",
  blockersLink: "nav-blockers-link",
  myDocumentsLink: "nav-my-documents-link",
  reportingLink: "nav-reporting-link",
  settingsLink: "nav-settings-link",
};

export const HEADER = {
  userMenu: "header-user-menu",
  userMenuTrigger: "header-user-menu-trigger",
  logoutButton: "header-logout-button",
};

export const LANDING = {
  signInButton: "landing-sign-in-button",
  loginNav: "landing-login-nav",
  requestDemoHero: "landing-request-demo-hero",
  requestDemoNav: "landing-request-demo-nav",
  requestDemoClosing: "landing-request-demo-closing",
  demoModal: "landing-demo-modal",
  demoName: "landing-demo-name",
  demoEmail: "landing-demo-email",
  demoCompany: "landing-demo-company",
  demoMessage: "landing-demo-message",
  demoSubmit: "landing-demo-submit",
  demoClose: "landing-demo-close",
  demoSuccess: "landing-demo-success",
};

export const DASHBOARD = {
  root: "dashboard-root",
  welcomeHeading: "dashboard-welcome-heading",
  brandsCard: "dashboard-brands-card",
  usersCard: "dashboard-users-card",
  locationsCard: "dashboard-locations-card",
};

export const BRAND_LIST = {
  root: "brand-list-root",
  createButton: "brand-list-create-button",
  createNameInput: "brand-list-create-name-input",
  createDescInput: "brand-list-create-desc-input",
  createSubmit: "brand-list-create-submit",
  createCancel: "brand-list-create-cancel",
  rowPrefix: "brand-row-", // append brand_id
};

export const BRAND_DETAIL = {
  root: "brand-detail-root",
  membersTab: "brand-detail-members-tab",
  locationsTab: "brand-detail-locations-tab",
  // Members
  inviteButton: "brand-detail-invite-button",
  inviteEmailInput: "brand-detail-invite-email-input",
  inviteNameInput: "brand-detail-invite-name-input",
  inviteRoleSelect: "brand-detail-invite-role-select",
  inviteSubmit: "brand-detail-invite-submit",
  inviteCancel: "brand-detail-invite-cancel",
  memberRowPrefix: "brand-member-row-",
  // Locations
  addLocationButton: "brand-detail-add-location-button",
  locationNameInput: "brand-detail-location-name-input",
  locationAddressInput: "brand-detail-location-address-input",
  locationCityInput: "brand-detail-location-city-input",
  locationStateInput: "brand-detail-location-state-input",
  locationPostalInput: "brand-detail-location-postal-input",
  locationPhoneInput: "brand-detail-location-phone-input",
  locationSubmit: "brand-detail-location-submit",
  locationCancel: "brand-detail-location-cancel",
  locationRowPrefix: "brand-location-row-",
};
